// assets/free-gifts.js


!function () {
  "use strict";

  /* =========================================================
     FREE GIFTS CONFIG
  ========================================================= */

  var configs = [
    {
      brandName: "Arencia",
      vendor: "arencia",
      requiredQty: 2,
      giftVariantId: 52120079859941,
      giftProductId: 9761080541413
    },
    {
      brandName: "Tocobo",
      vendor: "tocobo",
      requiredQty: 2,
      giftVariantId: 52133653184741,
      giftProductId: 9765192270053
    }
  ];


  /* =========================================================
     STATE
  ========================================================= */

  var state = {
    initialized: false,

    syncing: false,
    syncAgain: false,
    currentSyncPromise: null,

    internalOperation: false,

    productAddInProgress: false,
    productSubmitLocked: false,

    giftOperationInProgress: false,

    loaderVisible: false,

    cartReloadScheduled: false,

    relevantSignature: null,

    cartActionChecking: false
  };


  /* =========================================================
     LOG
  ========================================================= */

  function log() {

    if (
      window.console &&
      typeof console.log === "function"
    ) {

      console.log.apply(
        console,
        ["[Free Gifts]"].concat(
          Array.prototype.slice.call(arguments)
        )
      );
    }
  }


  function errorLog() {

    if (
      window.console &&
      typeof console.error === "function"
    ) {

      console.error.apply(
        console,
        ["[Free Gifts Error]"].concat(
          Array.prototype.slice.call(arguments)
        )
      );
    }
  }


  function num(value) {

    var n = Number(value);

    return isNaN(n) ? 0 : n;
  }


  /* =========================================================
     CART PAGE CHECK
  ========================================================= */

  function isCartPage() {

    return (
      window.location.pathname === "/cart" ||
      window.location.pathname.indexOf("/cart") === 0
    );
  }


  /* =========================================================
     CHECK FREE GIFT
  ========================================================= */

  function isGiftItem(item) {

    if (!item) {
      return false;
    }

    var productId =
      num(item.product_id);

    var variantId =
      num(item.variant_id);

    for (
      var x = 0;
      x < configs.length;
      x++
    ) {

      var config =
        configs[x];

      if (
        productId ===
        num(config.giftProductId)
      ) {

        return true;
      }

      if (
        variantId ===
        num(config.giftVariantId)
      ) {

        return true;
      }
    }

    return false;
  }


  /* =========================================================
     GET BRAND QUANTITY

     IMPORTANT:
     FREE GIFT IS NOT COUNTED
  ========================================================= */

  function getBrandQuantity(
    cart,
    config
  ) {

    if (
      !cart ||
      !Array.isArray(cart.items)
    ) {

      return 0;
    }

    var total = 0;

    cart.items.forEach(
      function (item) {

        /*
         * Don't count free gift
         */
        if (
          isGiftItem(item)
        ) {

          return;
        }

        var itemVendor =
          String(
            item.vendor || ""
          )
            .trim()
            .toLowerCase();

        var configVendor =
          String(
            config.vendor || ""
          )
            .trim()
            .toLowerCase();

        if (
          itemVendor ===
          configVendor
        ) {

          total +=
            num(item.quantity);
        }
      }
    );

    return total;
  }


  /* =========================================================
     FIND GIFT
  ========================================================= */

  function findGift(
    cart,
    config
  ) {

    if (
      !cart ||
      !Array.isArray(cart.items)
    ) {

      return null;
    }

    for (
      var x = 0;
      x < cart.items.length;
      x++
    ) {

      var item =
        cart.items[x];

      if (
        num(item.product_id) ===
        num(config.giftProductId)
      ) {

        return item;
      }

      if (
        num(item.variant_id) ===
        num(config.giftVariantId)
      ) {

        return item;
      }
    }

    return null;
  }


  /* =========================================================
     ONLY ARANCIA / TOCOBO SIGNATURE

     Example:

     Arencia:1:0|Tocobo:2:1

     Last number = gift quantity
  ========================================================= */

  function getRelevantSignature(
    cart
  ) {

    var result = [];

    configs.forEach(
      function (config) {

        var quantity =
          getBrandQuantity(
            cart,
            config
          );

        var gift =
          findGift(
            cart,
            config
          );

        result.push(
          config.brandName +
          ":" +
          quantity +
          ":" +
          (
            gift
              ? num(gift.quantity)
              : 0
          )
        );
      }
    );

    return result.join("|");
  }


  /* =========================================================
     GET CART
  ========================================================= */

  function getCart() {

    return fetch(
      "/cart.js?_free_gifts=" +
      Date.now(),
      {
        method: "GET",

        credentials:
          "same-origin",

        headers: {
          Accept:
            "application/json"
        },

        cache:
          "no-store"
      }
    )
    .then(
      function (response) {

        if (!response.ok) {

          throw new Error(
            "Unable to fetch cart"
          );
        }

        return response.json();
      }
    );
  }


  /* =========================================================
     LOADER STYLE
  ========================================================= */

  function createLoaderStyle() {

    if (
      document.getElementById(
        "free-gifts-loader-style"
      )
    ) {

      return;
    }

    var style =
      document.createElement(
        "style"
      );

    style.id =
      "free-gifts-loader-style";

    style.innerHTML =

      "#free-gifts-loader{" +

      "position:fixed;" +
      "inset:0;" +
      "z-index:999999;" +

      "display:flex;" +
      "align-items:center;" +
      "justify-content:center;" +

      "background:rgba(255,255,255,.60);" +

      "backdrop-filter:blur(2px);" +

      "}" +

      ".free-gifts-loader-box{" +

      "display:flex;" +
      "align-items:center;" +
      "gap:12px;" +

      "padding:14px 20px;" +

      "background:#fff;" +

      "border-radius:8px;" +

      "box-shadow:0 4px 25px rgba(0,0,0,.15);" +

      "font-size:14px;" +

      "font-weight:600;" +

      "color:#222;" +

      "}" +

      ".free-gifts-spinner{" +

      "width:20px;" +
      "height:20px;" +

      "border:3px solid #ddd;" +

      "border-top-color:#111;" +

      "border-radius:50%;" +

      "animation:freeGiftSpin .7s linear infinite;" +

      "}" +

      "@keyframes freeGiftSpin{" +

      "to{transform:rotate(360deg)}" +

      "}";

    document.head.appendChild(
      style
    );
  }


  /* =========================================================
     SHOW LOADER
  ========================================================= */

  function showLoader(
    message
  ) {

    if (
      state.loaderVisible
    ) {

      return;
    }

    state.loaderVisible =
      true;

    createLoaderStyle();

    var loader =
      document.createElement(
        "div"
      );

    loader.id =
      "free-gifts-loader";

    loader.innerHTML =

      '<div class="free-gifts-loader-box">' +

        '<div class="free-gifts-spinner"></div>' +

        '<span>' +

          (
            message ||
            ""
          ) +

        '</span>' +

      '</div>';

    document.body.appendChild(
      loader
    );
  }


  /* =========================================================
     HIDE LOADER
  ========================================================= */

  function hideLoader() {

    state.loaderVisible =
      false;

    var loader =
      document.getElementById(
        "free-gifts-loader"
      );

    if (loader) {

      loader.remove();
    }
  }


  /* =========================================================
     CART COUNT UPDATE
  ========================================================= */

  function updateCartCount(
    cart
  ) {

    if (
      !cart ||
      !window.jQuery
    ) {

      return;
    }

    var count =
      num(cart.item_count);

    $(
      ".cart-count, " +
      ".cart__count, " +
      ".site-header__cart-count"
    ).text(count);

    if (
      count > 0
    ) {

      $(
        ".site-header__cart-indicator"
      ).removeClass(
        "hide"
      );
    }

    $(
      document
    ).trigger(
      "free-gifts:updated",
      [cart]
    );
  }


  /* =========================================================
     AUTOMATIC CART RELOAD

     ONLY runs when gift actually changed.

     This makes the newly added/removed gift
     immediately visible in the cart UI.
  ========================================================= */

  function reloadCartAutomatically() {

    if (
      !isCartPage()
    ) {

      return;
    }

    if (
      state.cartReloadScheduled
    ) {

      return;
    }

    state.cartReloadScheduled =
      true;

    log(
      "Gift changed -> automatic cart refresh"
    );

    /*
     * Give Shopify/theme a tiny moment
     * to finish the AJAX operation.
     */

    setTimeout(
      function () {

        hideLoader();

        window.location.reload();

      },
      180
    );
  }


  /* =========================================================
     ADD FREE GIFT
  ========================================================= */

  function addGift(
    config
  ) {

    if (
      state.giftOperationInProgress
    ) {

      return Promise.resolve({
        changed: false
      });
    }

    state.giftOperationInProgress =
      true;

    state.internalOperation =
      true;

    showLoader(
      ""
    );

    log(
      "ADDING GIFT:",
      config.brandName
    );

    return fetch(
      "/cart/add.js",
      {
        method: "POST",

        credentials:
          "same-origin",

        headers: {

          "Content-Type":
            "application/json",

          Accept:
            "application/json"
        },

        body:
          JSON.stringify({

            items: [

              {

                id:
                  num(
                    config.giftVariantId
                  ),

                quantity: 1

              }

            ]

          })
      }
    )
    .then(
      function (response) {

        if (
          !response.ok
        ) {

          throw new Error(
            "Gift add failed"
          );
        }

        return response.json();
      }
    )
    .then(
      function (data) {

        log(
          "GIFT ADDED:",
          config.brandName
        );

        return {
          changed: true,
          cart: data
        };
      }
    )
    .catch(
      function (err) {

        errorLog(
          "Gift add error:",
          config.brandName,
          err
        );

        return {
          changed: false
        };
      }
    )
    .finally(
      function () {

        state.giftOperationInProgress =
          false;

        state.internalOperation =
          false;

      }
    );
  }


  /* =========================================================
     REMOVE FREE GIFT
  ========================================================= */

  function removeGift(
    giftItem,
    config
  ) {

    if (
      !giftItem ||
      !giftItem.key
    ) {

      return Promise.resolve({
        changed: false
      });
    }

    if (
      state.giftOperationInProgress
    ) {

      return Promise.resolve({
        changed: false
      });
    }

    state.giftOperationInProgress =
      true;

    state.internalOperation =
      true;

    showLoader(
      ""
    );

    log(
      "REMOVING GIFT:",
      config.brandName
    );

    return fetch(
      "/cart/change.js",
      {
        method: "POST",

        credentials:
          "same-origin",

        headers: {

          "Content-Type":
            "application/json",

          Accept:
            "application/json"
        },

        body:
          JSON.stringify({

            id:
              giftItem.key,

            quantity: 0

          })
      }
    )
    .then(
      function (response) {

        if (
          !response.ok
        ) {

          throw new Error(
            "Gift remove failed"
          );
        }

        return response.json();
      }
    )
    .then(
      function (data) {

        log(
          "GIFT REMOVED:",
          config.brandName
        );

        return {
          changed: true,
          cart: data
        };
      }
    )
    .catch(
      function (err) {

        errorLog(
          "Gift remove error:",
          config.brandName,
          err
        );

        return {
          changed: false
        };
      }
    )
    .finally(
      function () {

        state.giftOperationInProgress =
          false;

        state.internalOperation =
          false;
      }
    );
  }


  /* =========================================================
     FORCE GIFT QUANTITY TO 1
  ========================================================= */

  function forceGiftQuantity(
    giftItem,
    config
  ) {

    if (
      !giftItem ||
      !giftItem.key
    ) {

      return Promise.resolve({
        changed: false
      });
    }

    state.internalOperation =
      true;

    showLoader(
      ""
    );

    log(
      "FORCING GIFT QUANTITY = 1:",
      config.brandName
    );

    return fetch(
      "/cart/change.js",
      {
        method: "POST",

        credentials:
          "same-origin",

        headers: {

          "Content-Type":
            "application/json",

          Accept:
            "application/json"
        },

        body:
          JSON.stringify({

            id:
              giftItem.key,

            quantity: 1

          })
      }
    )
    .then(
      function (response) {

        if (
          !response.ok
        ) {

          throw new Error(
            "Gift quantity update failed"
          );
        }

        return response.json();
      }
    )
    .then(
      function (data) {

        log(
          "GIFT QUANTITY FIXED:",
          config.brandName
        );

        return {
          changed: true,
          cart: data
        };
      }
    )
    .catch(
      function (err) {

        errorLog(
          "Gift quantity error:",
          config.brandName,
          err
        );

        return {
          changed: false
        };
      }
    )
    .finally(
      function () {

        state.internalOperation =
          false;
      }
    );
  }


  /* =========================================================
     MAIN GIFT SYNC
  ========================================================= */

  function syncGifts(
    force
  ) {

    if (
      state.syncing
    ) {

      state.syncAgain =
        true;

      return (
        state.currentSyncPromise ||
        Promise.resolve({
          changed: false
        })
      );
    }

    state.syncing =
      true;

    state.syncAgain =
      false;

    var anyGiftChanged =
      false;

    var operations = [];

    var promise =
      getCart()

      .then(
        function (cart) {

          /*
           * Check ONLY:
           * Arencia
           * Tocobo
           */

          configs.forEach(
            function (config) {

              var brandQty =
                getBrandQuantity(
                  cart,
                  config
                );

              var gift =
                findGift(
                  cart,
                  config
                );

              log(
                config.brandName,

                "| Qty:",
                brandQty,

                "| Required:",
                config.requiredQty,

                "| Gift:",
                !!gift
              );


              /* =====================================
                 QUALIFIED
                 QUANTITY >= 2
              ===================================== */

              if (
                brandQty >=
                config.requiredQty
              ) {

                /*
                 * Gift missing
                 */

                if (!gift) {

                  operations.push(
                    function () {

                      return addGift(
                        config
                      )
                      .then(
                        function (result) {

                          if (
                            result &&
                            result.changed
                          ) {

                            anyGiftChanged =
                              true;
                          }

                          return result;
                        }
                      );
                    }
                  );
                }

                /*
                 * Gift quantity must always be 1
                 */

                else if (
                  num(
                    gift.quantity
                  ) !== 1
                ) {

                  operations.push(
                    function () {

                      return forceGiftQuantity(
                        gift,
                        config
                      )
                      .then(
                        function (result) {

                          if (
                            result &&
                            result.changed
                          ) {

                            anyGiftChanged =
                              true;
                          }

                          return result;
                        }
                      );
                    }
                  );
                }
              }


              /* =====================================
                 NOT QUALIFIED
                 QUANTITY < 2
              ===================================== */

              else {

                /*
                 * Gift exists but user no longer
                 * qualifies -> REMOVE
                 */

                if (gift) {

                  operations.push(
                    function () {

                      return removeGift(
                        gift,
                        config
                      )
                      .then(
                        function (result) {

                          if (
                            result &&
                            result.changed
                          ) {

                            anyGiftChanged =
                              true;
                          }

                          return result;
                        }
                      );
                    }
                  );
                }
              }
            }
          );


          /*
           * Run operations one by one
           */

          function run(
            index
          ) {

            if (
              index >=
              operations.length
            ) {

              return Promise.resolve();
            }

            return operations[index]()
              .then(
                function () {

                  return run(
                    index + 1
                  );
                }
              );
          }

          return run(0);
        }
      )

      .then(
        function () {

          /*
           * Get final cart after gift
           * operation.
           */

          return getCart();
        }
      )

      .then(
        function (finalCart) {

          state.relevantSignature =
            getRelevantSignature(
              finalCart
            );

          updateCartCount(
            finalCart
          );

          /*
           * ONLY automatic reload if:
           *
           * gift actually changed
           *
           * AND
           *
           * we're already on cart page
           */

          if (
            anyGiftChanged &&
            isCartPage()
          ) {

            reloadCartAutomatically();
          }

          return {
            changed:
              anyGiftChanged,

            cart:
              finalCart
          };
        }
      )
      .catch(
        function (err) {

          errorLog(
            "Gift sync failed:",
            err
          );

          hideLoader();

          return {
            changed: false
          };
        }
      )
      .finally(
        function () {

          state.syncing =
            false;

          state.currentSyncPromise =
            null;
        }
      );


    state.currentSyncPromise =
      promise;

    return promise;
  }


  /* =========================================================
     WAIT FOR REAL CART CHANGE

     This is the important part for:
       + button
       - button
       Remove button

     We DO NOT assume Shopify has finished.
     We keep checking /cart.js until the
     actual Arencia/Tocobo quantity changes.
  ========================================================= */

  function waitForRelevantCartChange(
    oldSignature,
    attempt
  ) {

    /*
     * Maximum:
     * 30 x 150ms = 4.5 seconds
     */

    if (
      attempt >= 30
    ) {

      log(
        "Cart update wait finished."
      );

      getCart()
        .then(
          function (cart) {

            var finalSignature =
              getRelevantSignature(
                cart
              );

            if (
              finalSignature !==
              oldSignature
            ) {

              log(
                "FINAL CART CHANGE FOUND:",
                finalSignature
              );

              state.relevantSignature =
                finalSignature;

              syncGifts(true);
            }

          }
        )
        .catch(
          function () {}
        );

      return;
    }


    setTimeout(
      function () {

        /*
         * Don't check while our own
         * gift operation is running.
         */

        if (
          state.internalOperation ||
          state.productAddInProgress
        ) {

          waitForRelevantCartChange(
            oldSignature,
            attempt + 1
          );

          return;
        }


        getCart()
          .then(
            function (cart) {

              var newSignature =
                getRelevantSignature(
                  cart
                );

              log(
                "CART CHECK #" +
                (attempt + 1),

                newSignature
              );


              /*
               * ACTUAL Arencia/Tocobo
               * quantity changed.
               */

              if (
                newSignature !==
                oldSignature
              ) {

                log(
                  "REAL ARANCIA/TOCOBO CHANGE DETECTED"
                );

                log(
                  "OLD:",
                  oldSignature
                );

                log(
                  "NEW:",
                  newSignature
                );

                state.relevantSignature =
                  newSignature;

                /*
                 * NOW run gift logic.
                 */

                syncGifts(true);

                return;
              }


              /*
               * Still old cart.
               * Theme hasn't finished yet.
               */

              waitForRelevantCartChange(
                oldSignature,
                attempt + 1
              );
            }
          )
          .catch(
            function () {

              waitForRelevantCartChange(
                oldSignature,
                attempt + 1
              );
            }
          );

      },
      150
    );
  }


  /* =========================================================
     CART +/- / REMOVE WATCHER
  ========================================================= */

  function setupCartQuantityWatcher() {

    if (
      !isCartPage()
    ) {

      return;
    }


    var selector = [

      ".js-qty__adjust",

      ".quantity__button",

      ".quantity-selector button",

      ".cart__qty-adjust",

      ".cart-item__quantity button",

      "[data-quantity-button]",

      'button[name="minus"]',

      'button[name="plus"]',

      "[data-quantity-minus]",

      "[data-quantity-plus]",

      "[data-cart-remove]",

      ".cart__remove",

      ".remove-item",

      ".cart-item__remove",

      "[data-cart-remove-item]"

    ].join(",");


    /*
     * + / - / REMOVE buttons
     */

    document.addEventListener(
      "click",
      function (event) {

        var button =
          event.target &&
          event.target.closest(
            selector
          );

        if (!button) {
          return;
        }

        if (
          state.internalOperation ||
          state.productAddInProgress
        ) {

          return;
        }


        log(
          "CART +/-/REMOVE CLICK DETECTED"
        );


        /*
         * Get cart BEFORE theme changes it.
         */

        getCart()
          .then(
            function (beforeCart) {

              var oldSignature =
                getRelevantSignature(
                  beforeCart
                );

              log(
                "CART BEFORE ACTION:",
                oldSignature
              );


              /*
               * Wait for theme to finish.
               */

              waitForRelevantCartChange(
                oldSignature,
                0
              );
            }
          )
          .catch(
            function (err) {

              errorLog(
                "Before cart check failed:",
                err
              );
            }
          );

      },
      true
    );


    /*
     * Quantity INPUT change
     *
     * Some themes allow typing quantity
     * instead of clicking +/-
     */

    document.addEventListener(
      "change",
      function (event) {

        var input =
          event.target;

        if (!input) {
          return;
        }


        var isQuantityInput =
          input.matches(
            [
              'input[name="updates[]"]',

              "input[data-quantity-input]",

              ".cart__quantity input",

              ".quantity-selector input",

              "input.quantity-input",

              "input[data-cart-quantity]"

            ].join(",")
          );


        if (!isQuantityInput) {
          return;
        }


        if (
          state.internalOperation ||
          state.productAddInProgress
        ) {

          return;
        }


        log(
          "CART QUANTITY INPUT CHANGED"
        );


        getCart()
          .then(
            function (beforeCart) {

              var oldSignature =
                getRelevantSignature(
                  beforeCart
                );

              waitForRelevantCartChange(
                oldSignature,
                0
              );
            }
          )
          .catch(
            function () {}
          );

      },
      true
    );


    log(
      "SMART CART +/- / REMOVE WATCHER READY"
    );
  }


  /* =========================================================
     PRODUCT PAGE ADD TO CART

     Product add:
       BEFORE CART
       ↓
       ADD PRODUCT
       ↓
       GET NEW CART
       ↓
       If Arencia/Tocobo changed
       ↓
       ADD/REMOVE GIFT
       ↓
       REDIRECT /cart
  ========================================================= */

  function handleProductAdd(
    form
  ) {

    if (
      state.productSubmitLocked ||
      state.productAddInProgress
    ) {

      return;
    }


    state.productSubmitLocked =
      true;

    state.productAddInProgress =
      true;


    /*
     * Get cart BEFORE product add.
     *
     * This allows us to know whether
     * Arencia/Tocobo actually changed.
     */

    getCart()
      .then(
        function (beforeCart) {

          var beforeSignature =
            getRelevantSignature(
              beforeCart
            );


          var formData =
            new FormData(form);


          var quantityInput =
            form.querySelector(
              '[name="quantity"]'
            );


          var quantity =
            quantityInput
              ? num(
                  quantityInput.value
                )
              : 1;


          if (
            quantity < 1
          ) {

            quantity = 1;
          }


          log(
            "PRODUCT ADD STARTED",

            "| Quantity:",
            quantity,

            "| Before:",
            beforeSignature
          );


          return fetch(
            "/cart/add.js",
            {
              method: "POST",

              credentials:
                "same-origin",

              headers: {
                Accept:
                  "application/json"
              },

              body:
                formData
            }
          )
          .then(
            function (response) {

              if (
                !response.ok
              ) {

                throw new Error(
                  "Product add failed"
                );
              }

              return response.json();
            }
          )
          .then(
            function () {

              log(
                "PRODUCT ADDED SUCCESSFULLY"
              );


              /*
               * Get actual cart after
               * product was added.
               */

              return getCart()
                .then(
                  function (afterCart) {

                    var afterSignature =
                      getRelevantSignature(
                        afterCart
                      );


                    log(
                      "AFTER PRODUCT ADD:",
                      afterSignature
                    );


                    /*
                     * Only sync if
                     * Arencia/Tocobo
                     * actually changed.
                     */

                    if (
                      afterSignature !==
                      beforeSignature
                    ) {

                      return syncGifts(
                        true
                      );
                    }


                    /*
                     * Other brand:
                     *
                     * Don't waste gift
                     * operation.
                     */

                    log(
                      "OTHER PRODUCT ADDED - GIFT SYNC SKIPPED"
                    );

                    return {
                      changed: false
                    };
                  }
                );
            }
          );
        }
      )
      .then(
        function () {

          log(
            "PRODUCT + FREE GIFT COMPLETE"
          );


          /*
           * NOW redirect.
           *
           * If 2nd Arencia/Tocobo was added,
           * gift is already in cart.
           */

          window.location.href =
            "/cart";
        }
      )
      .catch(
        function (err) {

          errorLog(
            "Product add error:",
            err
          );


          window.location.href =
            "/cart";
        }
      )
      .finally(
        function () {

          state.productAddInProgress =
            false;

          state.productSubmitLocked =
            false;
        }
      );
  }


  /* =========================================================
     PRODUCT FORM INTERCEPT
  ========================================================= */

  function setupProductForms() {

    document.addEventListener(
      "submit",
      function (event) {

        var form =
          event.target;

        if (!form) {
          return;
        }


        var action =
          String(
            form.getAttribute(
              "action"
            ) || ""
          );


        var hasProductId =
          !!form.querySelector(
            '[name="id"]'
          );


        var isCartAdd =
          action.indexOf(
            "/cart/add"
          ) !== -1;


        var isCartForm =
          form.matches(
            'form[action*="/cart"]'
          );


        if (
          (
            isCartAdd ||
            hasProductId
          ) &&

          !(
            !isCartAdd &&
            isCartForm
          ) &&

          form.dataset
            .freeGiftHandled !==
            "true" &&

          !state.productSubmitLocked
        ) {

          event.preventDefault();

          event.stopImmediatePropagation();


          form.dataset
            .freeGiftHandled =
            "true";


          handleProductAdd(
            form
          );
        }

      },
      true
    );
  }


  /* =========================================================
     INITIAL CART CHECK

     When cart page loads:
       Check Arencia/Tocobo.
       
       If:
         Qty 1 + gift exists
           -> REMOVE gift + auto reload

         Qty 2 + gift missing
           -> ADD gift + auto reload

       If everything correct:
           -> NOTHING
           -> no reload
  ========================================================= */

  function initialCartCheck() {

    getCart()
      .then(
        function (cart) {

          var signature =
            getRelevantSignature(
              cart
            );

          state.relevantSignature =
            signature;


          log(
            "INITIAL CART CHECK:",
            signature
          );


          configs.forEach(
            function (config) {

              var qty =
                getBrandQuantity(
                  cart,
                  config
                );

              var gift =
                findGift(
                  cart,
                  config
                );

              log(
                config.brandName,

                "| Qty:",
                qty,

                "| Gift:",
                !!gift
              );
            }
          );


          /*
           * Force condition check.
           */

          return syncGifts(
            true
          );
        }
      )
      .catch(
        function (err) {

          errorLog(
            "Initial cart check failed:",
            err
          );
        }
      );
  }


  /* =========================================================
     INITIALIZE
  ========================================================= */

  function init() {

    if (
      state.initialized
    ) {

      return;
    }


    state.initialized =
      true;


    log(
      "=========================================="
    );

    log(
      "FREE GIFTS SYSTEM INITIALIZING"
    );

    log(
      "=========================================="
    );


    /*
     * Product page
     */

    setupProductForms();


    /*
     * Cart page +/-/remove
     */

    setupCartQuantityWatcher();


    /*
     * Cart page initial check
     */

    if (
      isCartPage()
    ) {

      setTimeout(
        function () {

          initialCartCheck();

        },
        100
      );

    } else {

      log(
        "Product page: waiting for Add to Cart."
      );
    }


    log(
      "FREE GIFTS SYSTEM READY"
    );
  }


  /* =========================================================
     START
  ========================================================= */

  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      init
    );

  } else {

    init();
  }


  /* =========================================================
     PUBLIC API
  ========================================================= */

  window.FreeGifts = {

    sync:
      function () {
        return syncGifts(true);
      },

    configs:
      configs

  };

}();